import { IconStorage } from "@app/shared/icons/interfaces";

export const alertTriangle: IconStorage = {
  svgCode: () => ([
    "M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z",
  ]),
};

export const alertTriangleColored: IconStorage = {
  svgCode: () => (
    <>
    <path
      d="M1.59216 12.0657L7.07541 2.59464C7.37846 2.07119 7.52998 1.80947 7.72767 1.72157C7.90011 1.64489 8.09696 1.64489 8.2694 1.72157C8.46709 1.80947 8.61861 2.07119 8.92166 2.59463L14.4049 12.0657C14.7091 12.591 14.8611 12.8537 14.8386 13.0693C14.819 13.2573 14.7205 13.4282 14.5676 13.5394C14.3923 13.6668 14.0888 13.6668 13.4818 13.6668H2.51528C1.90826 13.6668 1.60475 13.6668 1.42945 13.5394C1.27654 13.4282 1.17803 13.2573 1.15843 13.0693C1.13595 12.8537 1.28802 12.591 1.59216 12.0657Z"
      fill="#FFD654" stroke="#FFD654" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
    <path
      d="M8 6V8.66667M8 11.3333H8.00667" stroke="#32323C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </>
  ),
  svgProps: {
    height: "14.769",
    width: "16.329",
  }
};

export const alertHexagon: IconStorage = {
  svgCode: () => ([
    "M12 8.00008V12.0001M12 16.0001H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z",
  ]),
};
